var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#474a68",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2H4.2c-.318 0-.623.126-.849.351-.225.226-.351.53-.351.849v9.6c0 .318.126.623.351.848.226.226.53.352.849.352h7.2c.318 0 .623-.126.848-.351.226-.225.352-.53.352-.849V5.6L9 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2v3.6h3.6M10.198 8.6h-4.8M10.198 11h-4.8M6.598 6.2h-1.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.77fc47741efe622b9576ab9182bd55d8.svg";
export { ForwardRef as ReactComponent };